var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen4 = function SvgPen4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.898 18.102a2.18 2.18 0 0 1-.657-1.604q0-.946.657-1.6l9-9a2.17 2.17 0 0 1 1.6-.658q.945 0 1.604.658.657.657.657 1.604 0 .946-.657 1.6l-9 9a2.17 2.17 0 0 1-1.6.657q-.945 0-1.604-.657"
  })));
};
export default SvgPen4;